export { default } from './ProductComposition';
